import { initializeApp } from "firebase/app"
// import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyCpHLCLF3Y4Gmnv0OsgO_Pr5yj_9GcWDrw",
  authDomain: "gebi-b0e0c.firebaseapp.com",
  projectId: "gebi-b0e0c",
  storageBucket: "gebi-b0e0c.appspot.com",
  messagingSenderId: "690084918488",
  appId: "1:690084918488:web:cbf0fc21eb26f9d0edd3ad",
  measurementId: "G-BLWSN2RXF0"
}

const firebase = initializeApp(firebaseConfig)

// const projectAuth = getAuth(app)
// const projectFirestore = getFirestore(app)

// export { projectAuth, projectFirestore }
// export default projectFirestore;
export {firebase}